import {IStore} from "modules/types";

export const getChecksums = ({checksums}: IStore) => checksums;
